import { T as s, _ as o, s as r } from "./directive-CvGfmxqC.js";
class n extends o {
  constructor(t) {
    if (super(t), t.type !== r.EVENT || t.name !== "slotchange" || t.tagName !== "SLOT")
      throw new Error(
        "The `addListRole` directive must be used on a `<slot>` and the `slotchange` event"
      );
    this.part = t;
  }
  /**
   * Adds the list role to any <ul> or <ol> elements slotted into this slot
   * @param part
   */
  static addListRoleToSlotted(t) {
    if (t) {
      const e = (t == null ? void 0 : t.element).assignedElements();
      e == null || e.forEach((a) => {
        (a.tagName === "UL" || a.tagName === "OL") && (a.role = "list");
      });
    }
  }
  /**
   * Takes in a secondary function to be executed on slotchange. This is so that the user can still listen for slotchange
   * events when using this directive.
   * @param otherSlotChangeFunction Secondary slot change function to be called alongside this directive
   * @returns Empty string. When there is no return value, the event listeners are never properly attached.
   */
  render(t = void 0) {
    return this.part && (this.part.handleEvent = (e) => {
      this.part && n.addListRoleToSlotted(this.part), t && t(e);
    }), "";
  }
}
const i = s(n);
export {
  i as c
};
